export const operationTypesEnum = {
    TRANSFER: 'TRANSFER',
    SALES: 'SALES',
    PURCHASE: 'PURCHASE',
    REGISTRATION: 'REGISTRATION',
    WRITE_OFF: 'WRITE_OFF',
}

export const operationTypes = [
    {id: operationTypesEnum.TRANSFER, name: 'Inventory Transfers'},
    {id: operationTypesEnum.REGISTRATION, name: 'Registrations'},
    {id: operationTypesEnum.WRITE_OFF, name: 'Write-Offs'},
    {id: operationTypesEnum.SALES, name: 'Sales'},
    {id: operationTypesEnum.PURCHASE, name: 'Purchases'},
]

export const operationTypesFilter = (type) => {
    switch (type) {
        case operationTypesEnum.TRANSFER:
            return {id: operationTypesEnum.TRANSFER, name: 'Inventory Transfers'}

        case operationTypesEnum.SALES:
            return {id: operationTypesEnum.SALES, name: 'Sales'}

        case operationTypesEnum.PURCHASE:
            return {id: operationTypesEnum.PURCHASE, name: 'Purchases'}

        case operationTypesEnum.REGISTRATION:
            return {id: operationTypesEnum.REGISTRATION, name: 'Registrations'}
        case operationTypesEnum.WRITE_OFF:
            return {id: operationTypesEnum.WRITE_OFF, name: 'Write-Offs'}

        default:
            return {id: operationTypesEnum.TRANSFER, name: 'Inventory Transfers'}
    }
}


